// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__PEwdc","buttons":"PendingPaymentAlert_buttons__3-SfL"};